import shouldUseStandardGetStats from '../../helpers/shouldUseStandardGetStats';

const standardGetStats = (peerConnection, track, completion) => {
  peerConnection.getStats(track)
    .then(stats => completion(null, stats))
    .catch(completion);
};

const legacyGetStats = (peerConnection, _, completion) => {
  peerConnection.getStats((stats) => {
    completion(null, stats);
  }, completion);
};

const getStatsFn = shouldUseStandardGetStats ? standardGetStats : legacyGetStats;

// This returns the native or "raw" RtcStatsReport object.
// The standard Promise-based getStats() API is detected at call time by
// checking the return value – if it is a thenable we are on the standard
// path; otherwise we fall back to the legacy callback-based API.
const getRtcStatsReportAdapter = (peerConnection, track, completion) => {
  getStatsFn(peerConnection, track, completion);
};

export default getRtcStatsReportAdapter;
